import _ from 'lodash';
import {createSelector} from 'reselect';

import {AppState} from '../../appState';
import {getFlatPanels} from '../panelsSelectors';
import {EmlPanelId, PanelTypesEnum} from '../panelStateBase';

export interface EmlPanelProps {
  panelId: EmlPanelId;
}

function getPanel(state: AppState, props: EmlPanelProps) {
  return state.panels[props.panelId];
}

export function makeGetEmlPanel() {
  return createSelector(getPanel, (panel) => {
    // A corresponding panel should exist, otherwise we have a problem.
    if (!panel || panel.type !== PanelTypesEnum.EML) {
      throw new Error('This eml panel could not be found.');
    }

    return panel;
  });
}

export const getEmlPanels = createSelector([getFlatPanels], (panels) =>
  _(panels)
    .map((panel) => panel.type === PanelTypesEnum.EML && panel)
    .compact()
    .value(),
);
